export default [
    {
      name: "三十年资料",
      route: "/thirty/jingkai-thirty",
      icon: "party",
    },
  ];